import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { FUEL_PRICE_TREND } from "../../../constants/rto-constants";
import isObjectEmpty from "../../../utils/helpers/isObjectEmpty";
import { Label } from "@cars24/turbo-web/lib/label";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { ArrowIcon } from "@cars24/turbo-web/lib/icons/arrow-icon";
import { LinkButton } from "@cars24/turbo-web/lib/link-button";
import { NUMBER, redirect } from "../../../constants/app-constants";

// const fuelPrice = {
//     "date": "2024-08-28",
//     "placeName": "Delhi",
//     "dieselData": {
//         "price": "87.62",
//         "priceTrend": "INCREASED"
//     },
//     "petrolData": {
//         "price": "94.72",
//         "priceTrend": "DECREASED"
//     }
// };

const RenderPrice = ({ details, fuelType }) => {
    const { tokens } = useTokens();
    return (
        <div styleName={"styles.fuelCardText"}>
            <Label level={3} fontWeight="regular">{fuelType} / Ltr.</Label>
            <div styleName={"styles.price"}>
                <div styleName={"styles.rupeesIcon"}>
                    <Label level={1} fontWeight="semibold" color={tokens.text_default_text_primary}>₹</Label>
                </div>
                <Heading level={3} isBold color={tokens.text_default_text_primary}>{details.price}</Heading>
                {
                    FUEL_PRICE_TREND[details.priceTrend] &&
                    <ArrowIcon
                        size="60px"
                        rotateBy={details.priceTrend === FUEL_PRICE_TREND.DECREASED ? NUMBER.FOURTY_FIVE : -NUMBER.FOURTY_FIVE}
                        fill={details.priceTrend === FUEL_PRICE_TREND.DECREASED ? tokens.icon_state_icon_success : tokens.icon_state_icon_error}
                    />
                }
            </div>
        </div>
    );
};

const RtoVehInfoVehFuelPrice = ({
    fuelPrice
}) => {
    const { tokens } = useTokens();
    const { dieselData, petrolData, placeName = "" } = fuelPrice || {};

    if (isObjectEmpty(fuelPrice || {})) return null;

    return (
        <div styleName={"styles.fuelPriceContainer"}>
            {
                placeName &&
                <Heading level={NUMBER.TWO} fontWeight="semibold" color={tokens.text_default_text_primary}>Today’s fuel price in {placeName}</Heading>
            }
            <div styleName={"styles.fuelCardWrapper"}>
                <div styleName={"styles.fuelCard"}>
                    <RenderPrice details={petrolData} fuelType={"Petrol"}/>
                    <RenderPrice details={dieselData} fuelType={"Diesel"} />
                </div>
                <LinkButton
                    href={`${redirect.CONSUMER_WEB_IN}/fuel-price/`}
                    label="Check for other cities"
                    variant="brand"
                />
            </div>
        </div>
    );
};

RenderPrice.propTypes = {
    details: PropTypes.object,
    fuelType: PropTypes.string
};

RtoVehInfoVehFuelPrice.propTypes = {
    fuelPrice: PropTypes.object
};

export default RtoVehInfoVehFuelPrice;
